import React, { useEffect } from 'react'
import './ai-consulting-and-strategy.css'
import { Col, Container, Row } from 'react-bootstrap'
import Navigation from '../../../components/navigation/Navigation'
import Banner from '../../../components/banner/banner'
import MultiListCard from './multi-list-card/MultiListCard'
import Footer from '../../../components/footer/Footer';
import { APIINTEGRATION } from '../../../assets/images'
import SEO from '../../../components/seo/SEO'



const AiConsultingAndStrategy = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])



  return (
    <>
    <SEO
      title="AI Consulting & Strategy"
      description="Triumphal's AI consulting and strategy services help enterprises identify high-value Agentic AI use cases and build a responsible, scalable roadmap for adoption."
      path="/services/ai-consulting-and-strategy"
      keywords="AI consulting, AI strategy, AI roadmap, enterprise AI adoption"
    />
    <Navigation />
    <Banner title="AI Consulting & Strategy" bg={APIINTEGRATION} />

    <section className='api_intergration_section'>
        
        <Container className='mt-75 mb-75'>
            <div>
            <Row>
                <Col lg={11}>
                <div className='api_intergration_section_title'>

                    <h3>
                    Identify high ROI use cases and ship guardrailed agentic AI pilots in weeks aligned to your data, processes, and compliance needs.
                    </h3>

                </div>
                
                
                </Col>

            </Row>

            </div>
            <div className='api_intergration_section_img'>
                {/* <Row>
                    <Col>
                    <div className='text-center'>
                    <img className='img-fluid' src={APISERVICE} alt="imae" />
                    </div>

                  
                    
                    
                    </Col>
                </Row> */}




            </div>

            <div className='api_intergration_cards'>
                <MultiListCard  />
            </div>
          
        </Container>

    </section>

    <Footer />
        
    </>
  )
}

export default AiConsultingAndStrategy